import React, { useEffect, useRef } from "react";
import LegalDocument from "./LegalDocument";
import SiteFooter from "../../pages/home/landing/SiteFooter";
import EnquireDialog from "../../pages/home/landing/EnquireDialog";
import { mountEnquire } from "../../pages/home/landing/enquire";
import "../../pages/home/landing/live.css";
import styles from "./index.module.scss";

function titleOf(document, fallback) {
  const heading = document?.blocks?.find(block => block.type === "h");
  return heading?.runs?.map(run => run.text).join("") || fallback || "Imprint.live";
}

export default function LegalPage({ title: fallback, document }) {
  const title = titleOf(document, fallback);
  const footerRef = useRef(null);

  useEffect(() => mountEnquire(footerRef.current), []);

  useEffect(() => {
    const previous = window.document.title;
    window.document.title = `${title} - Imprint.live`;
    window.scrollTo(0, 0);
    return () => {
      window.document.title = previous;
    };
  }, [title]);

  return (
    <div className={styles.shell}>
      <div className={styles.band} style={{ backgroundImage: "url(/assets/header-band.webp)" }}>
        <a className={styles.announcement} href="/#safety">
          <strong>Introducing Imprint.live</strong>
          <span>A safe space for young people to build the skills they need for the digital world</span>
          <img src="/assets/icon-topbar-arrow.png" width="20" height="10" alt="" />
        </a>
        <header className={styles.header}>
          <a className={styles.logo} href="/" aria-label="Imprint.live home">
            <img src="/assets/8db50.svg" alt="" />
            <img className={styles.wordmark} src="/assets/36517.svg" alt="Imprint.live" />
          </a>
          <nav className={styles.nav} aria-label="Main">
            <a className={styles.back} href="/">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M19 12H5M11 6l-6 6 6 6" />
              </svg>
              Back to Home
            </a>
            <a className={styles.enquire} href="#enquire">Enquire Now</a>
          </nav>
        </header>
      </div>
      <main className={styles.page}>
        <div className={styles.doc}>
          <LegalDocument document={document} />
        </div>
      </main>
      <div className={`il-home ${styles.footerWrap}`} ref={footerRef}>
        <SiteFooter />
        <EnquireDialog />
      </div>
    </div>
  );
}
